module.exports = __webpack_public_path__ + "img/1503235208.4f4d75c9.jpg";